import React from "react";

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {}

const Image = ({ src, ...rest }: ImageProps) => (
    <img src={src ?? "/images/placeholder.png"} {...rest} />
);

export default Image;
